import React from 'react'
import cn from 'classnames'
import s from './PaginationToolbarStyle.module.scss'

export const Pagination: React.FC = ({ children }) => {
    return (
        <ul className={cn(s['pagination-list'], 'pagination-list')}>
            {children}
        </ul>
    )
}
